import { skipToken } from "@reduxjs/toolkit/query";
import { talentApi, useGetTalentQuery } from "../Redux/api/talentApi";
import { useAppDispatch, useAppSelector } from "../Redux/store";
import { ProfileType } from "../Types/General";
import { Talent } from "../Types/Talent";
import { formatUserName } from "../Utils/String";

interface useTalentHook {
    type: ProfileType;
    locator: string | undefined;
    talent: Talent | undefined,
    isTalentLoading: boolean,
    isTalentFetching: boolean
    getUsername: (full?: boolean) => string;
    // talentDashboardStats: {
    //     profileCompleteness: number;
    //     postedJobs: number;
    //     bookmarkedTalents: number;
    //     activeJobs: string[];
    //     lastJobPosting: string;
    //     lastTalent: string;
    //     loading: boolean;
    // },
    isActive: boolean;
    invalidateUser: () => void;
}

export const useTalent = (): useTalentHook => {
    /* ******************** Hooks ******************** */
    const dispatch = useAppDispatch();
    const { userId } = useAppSelector( state => state.Global);
    const type = ProfileType['Talent'];
    const {
        data: talent,
        isLoading: isTalentLoading,
        isFetching: isTalentFetching
    } = useGetTalentQuery( userId || skipToken);
    /* ******************** Variables ******************** */
    const isActive = talent?.active ?? false;
    const locator = talent?.locator;
    /* ******************** Functions ******************** */
    const getUsername = (full: boolean = false) => {
        return formatUserName(talent?.first_name, talent?.last_name, full)
    }
    const invalidateUser = () => {
        dispatch(talentApi.util.invalidateTags(["TalentData"]));
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return {
        type,
        getUsername,
        isActive,
        locator,
        invalidateUser,
        talent,
        isTalentLoading,
        isTalentFetching
    };
}